import React from 'react';
import { connect } from 'react-redux';
import { edit, getList } from './../Actions/newsCategory';
import Routes from './../Shared/routes';
import EditNewsSource from '../Components/NewsCategory/Item';
import NewsCategory from './../Entities/NewsCategory';
import { FILL_PARAMS_ERROR } from '../Shared/errors';

interface IProps {
    isLoading: boolean;
    error: number;
    list: NewsCategory[];
    edit: (id: number, title: string, color: string) => void;
    getNewsCategoryList: () => void;
    match: any;
    history: any;
}

interface IState {
    error: number | null;
}

class EditNewsCategoryPage extends React.Component<IProps, IState> {
    newsCategory: NewsCategory | undefined;

    state = {
        error: null
    }

    async componentDidMount() {
        if (!this.props.list.length) {
            await this.props.getNewsCategoryList();
        }
        const id = this.props.match.params.newsCategoryId;
        this.newsCategory = this.props.list.find((n: NewsCategory) => n.getId() == id);
        if (!this.newsCategory) {
            this.props.history.push(Routes.NEWS_CATEGORY_LIST);
        }
        else {
            this.forceUpdate();
        }
    }

    onSubmit = async (title: string, color: string) => {
        if (this.newsCategory) {
            if (title && color) {
                this.setState({
                    error: FILL_PARAMS_ERROR
                })
            }
            await this.props.edit(this.newsCategory.getId(), title, color);
            if (!this.props.error) {
                this.props.history.push(Routes.NEWS_CATEGORY_LIST);
            }
        }
    }

    render() {
        return (
            <EditNewsSource
                error={this.props.error || this.props.error}
                isLoading={this.props.isLoading}
                newsCategory={this.newsCategory}
                onSubmit={this.onSubmit}
            />
        );
    }
}

function bindAction(dispatch: any) {
    return {
        edit: (id: number, title: string, color: string) => dispatch(edit(id, title, color)),
        getNewsCategoryList: () => dispatch(getList())
    };
}

const mapStateToProps = (state: any) => {
    return {
        isLoading: state.newsCategory.isLoading,
        list: state.newsCategory.list,
        error: state.newsCategory.error
    }
}

export default connect(
    mapStateToProps,
    bindAction
)(EditNewsCategoryPage);
